import React, {ReactElement} from 'react';

import {
    GridFieldConfig,
    InnerFilters,
    InnerFiltersElement,
    InnerSortings,
    InnerSortingsElement,
} from 'types';

import {Config} from './Config';

export function mapListConfig(
    columns: GridFieldConfig[],
    filters?: InnerFilters,
    sortings?: InnerSortings,
    onFilterChange?: (value: InnerFiltersElement) => void,
    onFiltersSubmit?: () => void,
    onFiltersReset?: () => void,
    onSortingsChange?: (value: InnerSortingsElement[]) => void,
    showConfigBlock?: boolean,
): ReactElement {
    return (
        <Config
            columns={columns}
            filters={filters}
            sortings={sortings}
            onFilterChange={onFilterChange}
            onFiltersSubmit={onFiltersSubmit}
            onFiltersReset={onFiltersReset}
            onSortingChange={onSortingsChange}
            showConfigBlock={showConfigBlock}
        />
    );
}
